/*
 * File: CustomHeadline.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 10:45:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 19th May 2026 10:58:01 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../theme/Color';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import styles from './CustomHeadline.module.css';
import { Link } from 'react-router-dom';
import { title } from 'process';

type SportsProps = {
  link: '';
  title: '';
  source: '';
};
const CustomHeadline = ({ sportsData }: { sportsData: SportsProps[] }) => {
  return (
    <>
      {' '}
      {/* <Box
        sx={{
          padding: '12px',
          backgroundColor: zeplinColor.Neutral11,
          color: zeplinColor.Neutral1,
          // overflow: 'hidden',
          // display: 'inline',
          display: 'flex',
          alignItems: 'center',
          // textWrap: 'wrap',
          // width: '100%',
          height: { xs: '32px', xl: '40px' },
        }}
      >
        
        <Box className={styles['moving-element']}>
          {sportsData.map((val) =>
            val?.link || val?.title ? (
              <Box
                key={val?.link}
                sx={{
                  display: 'flex',
                  // flexWrap: 'nowrap',
                  // whiteSpace: 'nowrap',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                <img src={'/assets/sports-dot.svg'} width={6} height={6} />

                <Typography
                  sx={{
                    fontSize: { xs: '10px', xl: '13px' },
                    color: zeplinColor.Neutral1,
                    display: 'inline',
                    //   textWrap: 'wrap',
                  }}
                >
                  {val?.title}
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      fontSize: { xs: '10px', xl: '13px' },
                      color: zeplinColor.Brand2,
                      display: 'inline',
                      //   textWrap: 'wrap',
                    }}
                  >
                    -
                  </Typography>
                  <Link
                    to={val?.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                      textDecorationColor: zeplinColor.Brand2,
                      textUnderlineOffset: '2px',
                    }}
                    tabIndex={-1}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: '10px', xl: '13px' },
                        color: zeplinColor.Brand2,
                        display: 'inline',

                        //   textWrap: 'wrap',
                      }}
                    >
                      {val?.source}
                    </Typography>
                  </Link>
                </Box>
              </Box>
            ) : (
              ''
            ),
          )}
        </Box>
       
      </Box> */}
    </>
  );
};

export default CustomHeadline;
